import { render, staticRenderFns } from "./NotificationRow.vue?vue&type=template&id=23b35564&scoped=true&"
import script from "./NotificationRow.vue?vue&type=script&lang=js&"
export * from "./NotificationRow.vue?vue&type=script&lang=js&"
import style0 from "./NotificationRow.vue?vue&type=style&index=0&id=23b35564&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b35564",
  null
  
)

export default component.exports